module.exports = __webpack_public_path__ + "img/SJDLoader.f7b7e488.svg";